export const MATERIAL_RECIPE_COMPARISON_START =
  'material/material-recipe-comparison-start';
export const MATERIAL_RECIPE_COMPARISON_SUCCESS =
  'material/material-recipe-comparison-success';
export const MATERIAL_RECIPE_COMPARISON_ERROR =
  'material/material-recipe-comparison-error';
export const MATERIAL_RECIPE_COMPARISON_RESET =
  'material/material-recipe-comparison-reset';
